/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CommentEntityType } from './CommentEntityType';
import {
    CommentEntityTypeFromJSON,
    CommentEntityTypeFromJSONTyped,
    CommentEntityTypeToJSON,
} from './CommentEntityType';

/**
 * 
 * @export
 * @interface PinCommentRequestBody
 */
export interface PinCommentRequestBody {
    /**
     * 
     * @type {CommentEntityType}
     * @memberof PinCommentRequestBody
     */
    entityType: CommentEntityType;
    /**
     * ID of the entity (track) the comment is on
     * @type {number}
     * @memberof PinCommentRequestBody
     */
    entityId: number;
}

/**
 * Check if a given object implements the PinCommentRequestBody interface.
 */
export function instanceOfPinCommentRequestBody(value: object): value is PinCommentRequestBody {
    let isInstance = true;
    isInstance = isInstance && "entityType" in value && value["entityType"] !== undefined;
    isInstance = isInstance && "entityId" in value && value["entityId"] !== undefined;

    return isInstance;
}

export function PinCommentRequestBodyFromJSON(json: any): PinCommentRequestBody {
    return PinCommentRequestBodyFromJSONTyped(json, false);
}

export function PinCommentRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PinCommentRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entityType': CommentEntityTypeFromJSON(json['entityType']),
        'entityId': json['entityId'],
    };
}

export function PinCommentRequestBodyToJSON(value?: PinCommentRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entityType': CommentEntityTypeToJSON(value.entityType),
        'entityId': value.entityId,
    };
}

